export default __webpack_public_path__ + "login_background.2b74e87c.png";